import * as actionTypes from '../actions/types';

const initialState = {
  currentProgramDetails: {},
  programs: [],
  success: {
    create: '',
    update: '',
  },
  errors: {
    fetchMany: '',
    fetchOne: '',
    update: '',
    delete: '',
    create: '',
  },
};

const programReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PROGRAMS_SUCCESS:
      return {
        ...state,
        programs: [...action.payload],
        errors: { ...state.errors, fetchMany: '' },
      };

    case actionTypes.FETCH_PROGRAMS_ERROR:
      return {
        ...state,
        errors: { ...state.errors, fetchMany: action.payload },
      };

    case actionTypes.FETCH_PROGRAM_SUCCESS:
      return {
        ...state,
        currentProgramDetails: { ...action.payload },
        errors: { ...state.errors, fetchOne: '' },
      };

    case actionTypes.FETCH_PROGRAM_ERROR:
      return {
        ...state,
        currentProgramDetails: {},
        errors: { ...state.errors, fetchOne: action.payload },
      };

    case actionTypes.CREATE_PROGRAM_SUCCESS:
      return {
        ...state,
        programs: [...state.programs, { ...action.payload }],
        success: { ...state.success, create: 'Programa criado com sucesso!' },
      };

    case actionTypes.CREATE_PROGRAM_ERROR:
      return {
        ...state,
        errors: { ...state.errors, create: action.payload },
      };

    case actionTypes.DELETE_PROGRAM_SUCCESS:
      return {
        ...state,
        programs: [
          state.programs.filter(program => program.id !== action.payload),
        ],
        errors: { ...state.errors, delete: '' },
      };

    case actionTypes.DELETE_PROGRAM_ERROR:
      return {
        ...state,
        errors: { ...state.errors, delete: action.payload },
      };

    case actionTypes.UPDATE_PROGRAM_SUCCESS:
      const programUpdated = action.payload;

      const updateProgram = program => {
        if (program.id === programUpdated.id) {
          return programUpdated;
        }
        //return program;
      };

      return {
        ...state,
        programs: state.programs.map(updateProgram),
        success: {
          ...state.success,
          update: 'Informações atualizadas com sucesso!',
        },
      };

    case actionTypes.UPDATE_PROGRAM_ERROR:
      return {
        ...state,
        errors: { ...state.errors, update: action.payload },
      };
    case actionTypes.ON_CHANGE_NAME_PROGRAM:
      return {
        ...state,
        currentProgramDetails: {
          ...state.currentProgramDetails,
          name: action.payload.name,
        },
      };
    case actionTypes.RESET_MESSAGE:
      return {
        ...state,
        errors: initialState.errors,
        success: initialState.success,
      };
    case actionTypes.RESET_CURRENT_PROGRAM:
      return {
        ...state,
        currentProgramDetails: initialState.currentProgramDetails,
      };
    default:
      return state;
  }
};

export default programReducer;
